import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "关于我们", to: "/about" },
];

const hotLinks = [
  { label: "动作片推荐", to: "/category/movie?genre=action" },
  { label: "科幻片推荐", to: "/category/movie?genre=sci-fi" },
  { label: "爱情片推荐", to: "/category/movie?genre=romance" },
  { label: "悬疑剧推荐", to: "/category/tv?genre=mystery" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="mx-auto grid max-w-8xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-clapperboard-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-extrabold text-foreground-950">
              金桔<span className="text-primary-600">影院</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-800">
            金桔影院是一个专注于最新电影与电视剧推荐的内容门户，为你整理热门口碑佳作、分类筛选与作品详情，帮助你在观影前快速做出选择。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-secondary-700">
              本站为演示项目
            </span>
            <span className="rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-secondary-700">
              数据均为虚构内容
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">站内导航</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-secondary-700 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">热门入口</h3>
          <ul className="mt-4 flex flex-col gap-2.5">
            {hotLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-secondary-700 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex max-w-8xl flex-col gap-3 px-4 py-5 text-xs text-secondary-600 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 金桔影院 版权所有 · 本站内容仅供学习与演示，不提供任何影视播放与下载服务。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line"></i> hello@jinjucinema.com
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-weibo-line"></i> @金桔影院
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}